// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VN7tT4wZJ_Ip5v_xlpCA {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  isolation: isolate;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 11px;
}

.g_m2svLoAHFrinRrDh3y {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.eJbhaomb9AChVO9lC4rV,
.goyqyTl1QwqIbAzKwFc0 {
  position: absolute;
  left: 0;
  right: 0;
  height: 0;
  border-top: 1px solid;
}

.eJbhaomb9AChVO9lC4rV {
  border-color: #16a34a;
}

.goyqyTl1QwqIbAzKwFc0 {
  border-color: #dc2626;
}

.WQx5DICzWn0JgpM0w_1c {
  position: absolute;
  left: 4px;
  transform: translateY(-50%);
  padding: 2px 8px;
  border-radius: 4px;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  color: var(--vnsc-text-primary, #e0e0e0);
  white-space: nowrap;
}

.UoBjNzHtoQtKtJn1rAyR {
  position: absolute;
  right: 64px;
  transform: translateY(-50%);
  display: flex;
  gap: 4px;
  pointer-events: auto;
}

.eEEpHaEeO9KbfZI1UPa_ {
  min-width: 22px;
  height: 22px;
  border-radius: 4px;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-secondary, #111820);
  color: var(--vnsc-text-primary, #e0e0e0);
  cursor: pointer;
  font-size: 11px;
}

.eEEpHaEeO9KbfZI1UPa_:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* TVP-A1: pill strip liên hoàn — container KHÔNG bắt chuột (pointer-events kế thừa
   none từ .layer), chỉ nút con mới auto. Không đổi cũng không thêm pointer-events ở đây. */
.TWq7zBM3kX_iBV1J1n9_ {
  position: absolute;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  border-radius: 6px;
  background: rgba(17, 24, 32, 0.88);
  backdrop-filter: blur(4px);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  color: var(--vnsc-text-primary, #e0e0e0);
  white-space: nowrap;
  font-size: 11px;
}

.cEaYSnq4ygkWWN5AvdZw {
  padding: 0 2px;
  opacity: 0.92;
}

.WKkY1du74GfoicWPdtBS {
  min-width: 22px;
  height: 22px;
  border-radius: 4px;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-size: 11px;
  pointer-events: auto;
}

.WKkY1du74GfoicWPdtBS:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.D5LTn8m18lidy3IOuVdU {
  position: absolute;
  width: 0;
  border-right: 1px dashed;
}

.zrPKlFJxLV4m4Ob4QdgR {
  position: absolute;
  transform: translateY(-50%);
  padding: 1px 6px;
  border-radius: 3px;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}

.AVe7BWuD9aq_AqDbWRCY {
  background: #16a34a;
}

.hr0obkoMcLIwQFRbKtrQ {
  background: #dc2626;
}

.E5EyVyDIPefaD6CTt5h5 {
  background: #64748b;
}

.xZ43hNSvzAlExFd6GGBt {
  position: absolute;
  left: 0;
  right: 0;
  height: 0;
  border-top: 1px dashed #eab308;
}

.wcfjSX0FF0skcbQfcGmq {
  position: absolute;
  right: 8px;
  transform: translateY(-50%);
  padding: 2px 8px;
  border-radius: 10px;
  background: #eab308;
  color: #111;
  font-weight: 700;
  cursor: grab;
  pointer-events: auto;
  user-select: none;
  touch-action: none;
  white-space: nowrap;
}

.wcfjSX0FF0skcbQfcGmq.TKnEeZNafti8zYalCPn_ {
  opacity: 0.45;
  cursor: not-allowed;
}

.LqsUo6uUPQsTlqcht89_ {
  position: absolute;
  right: 76px;
  transform: translateY(-50%);
  padding: 6px 10px;
  border-radius: 6px;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  color: var(--vnsc-text-primary, #e0e0e0);
  white-space: nowrap;
  pointer-events: none;
}

.g7FL8hm89rbTODerzYHi {
  position: absolute;
  left: 0;
  right: 0;
  height: 0;
  border-top: 1px dashed #94a3b8;
}

.f5s7Z39hvBufq9lsbrNV {
  position: absolute;
  right: 8px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 4px;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  color: var(--vnsc-text-primary, #e0e0e0);
  white-space: nowrap;
  pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/widget/trading/chart/TradingOverlays.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yDAAyD;EACzD,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,6CAA6C;EAC7C,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,6CAA6C;EAC7C,wCAAwC;EACxC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;2FAC2F;AAC3F;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,6CAA6C;EAC7C,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;EAC7C,6CAA6C;EAC7C,wCAAwC;EACxC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,6CAA6C;EAC7C,wCAAwC;EACxC,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":[".host {\r\n  position: absolute;\r\n  inset: 0;\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n  isolation: isolate;\r\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\r\n  font-size: 11px;\r\n}\r\n\r\n.layer {\r\n  position: absolute;\r\n  inset: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.positionLineLong,\r\n.positionLineShort {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  height: 0;\r\n  border-top: 1px solid;\r\n}\r\n\r\n.positionLineLong {\r\n  border-color: #16a34a;\r\n}\r\n\r\n.positionLineShort {\r\n  border-color: #dc2626;\r\n}\r\n\r\n.badge {\r\n  position: absolute;\r\n  left: 4px;\r\n  transform: translateY(-50%);\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  white-space: nowrap;\r\n}\r\n\r\n.posButtons {\r\n  position: absolute;\r\n  right: 64px;\r\n  transform: translateY(-50%);\r\n  display: flex;\r\n  gap: 4px;\r\n  pointer-events: auto;\r\n}\r\n\r\n.iconBtn {\r\n  min-width: 22px;\r\n  height: 22px;\r\n  border-radius: 4px;\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  cursor: pointer;\r\n  font-size: 11px;\r\n}\r\n\r\n.iconBtn:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* TVP-A1: pill strip liên hoàn — container KHÔNG bắt chuột (pointer-events kế thừa\r\n   none từ .layer), chỉ nút con mới auto. Không đổi cũng không thêm pointer-events ở đây. */\r\n.pillStrip {\r\n  position: absolute;\r\n  transform: translateY(-50%);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 2px 6px;\r\n  border-radius: 6px;\r\n  background: rgba(17, 24, 32, 0.88);\r\n  backdrop-filter: blur(4px);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  white-space: nowrap;\r\n  font-size: 11px;\r\n}\r\n\r\n.pillChip {\r\n  padding: 0 2px;\r\n  opacity: 0.92;\r\n}\r\n\r\n.pillBtn {\r\n  min-width: 22px;\r\n  height: 22px;\r\n  border-radius: 4px;\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: transparent;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  font-size: 11px;\r\n  pointer-events: auto;\r\n}\r\n\r\n.pillBtn:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.bracketConnector {\r\n  position: absolute;\r\n  width: 0;\r\n  border-right: 1px dashed;\r\n}\r\n\r\n.axisTag {\r\n  position: absolute;\r\n  transform: translateY(-50%);\r\n  padding: 1px 6px;\r\n  border-radius: 3px;\r\n  color: #fff;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n}\r\n\r\n.axisTagBuy {\r\n  background: #16a34a;\r\n}\r\n\r\n.axisTagSell {\r\n  background: #dc2626;\r\n}\r\n\r\n.axisTagOrder {\r\n  background: #64748b;\r\n}\r\n\r\n.dashedLine {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  height: 0;\r\n  border-top: 1px dashed #eab308;\r\n}\r\n\r\n.handle {\r\n  position: absolute;\r\n  right: 8px;\r\n  transform: translateY(-50%);\r\n  padding: 2px 8px;\r\n  border-radius: 10px;\r\n  background: #eab308;\r\n  color: #111;\r\n  font-weight: 700;\r\n  cursor: grab;\r\n  pointer-events: auto;\r\n  user-select: none;\r\n  touch-action: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.handle.disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.tooltip {\r\n  position: absolute;\r\n  right: 76px;\r\n  transform: translateY(-50%);\r\n  padding: 6px 10px;\r\n  border-radius: 6px;\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  white-space: nowrap;\r\n  pointer-events: none;\r\n}\r\n\r\n.pendingLine {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  height: 0;\r\n  border-top: 1px dashed #94a3b8;\r\n}\r\n\r\n.pendingLabel {\r\n  position: absolute;\r\n  right: 8px;\r\n  transform: translateY(-50%);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  white-space: nowrap;\r\n  pointer-events: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"host": `VN7tT4wZJ_Ip5v_xlpCA`,
	"layer": `g_m2svLoAHFrinRrDh3y`,
	"positionLineLong": `eJbhaomb9AChVO9lC4rV`,
	"positionLineShort": `goyqyTl1QwqIbAzKwFc0`,
	"badge": `WQx5DICzWn0JgpM0w_1c`,
	"posButtons": `UoBjNzHtoQtKtJn1rAyR`,
	"iconBtn": `eEEpHaEeO9KbfZI1UPa_`,
	"pillStrip": `TWq7zBM3kX_iBV1J1n9_`,
	"pillChip": `cEaYSnq4ygkWWN5AvdZw`,
	"pillBtn": `WKkY1du74GfoicWPdtBS`,
	"bracketConnector": `D5LTn8m18lidy3IOuVdU`,
	"axisTag": `zrPKlFJxLV4m4Ob4QdgR`,
	"axisTagBuy": `AVe7BWuD9aq_AqDbWRCY`,
	"axisTagSell": `hr0obkoMcLIwQFRbKtrQ`,
	"axisTagOrder": `E5EyVyDIPefaD6CTt5h5`,
	"dashedLine": `xZ43hNSvzAlExFd6GGBt`,
	"handle": `wcfjSX0FF0skcbQfcGmq`,
	"disabled": `TKnEeZNafti8zYalCPn_`,
	"tooltip": `LqsUo6uUPQsTlqcht89_`,
	"pendingLine": `g7FL8hm89rbTODerzYHi`,
	"pendingLabel": `f5s7Z39hvBufq9lsbrNV`
};
export default ___CSS_LOADER_EXPORT___;
